<template>
  <v-dialog :value="showPreview" fullscreen transition="fade-transition" @input="onDialogInput">
    <div class="preview-video-container" @click="closePreview">
      <div class="preview-video__topbar">
        <v-btn v-if="options.copy" icon title="Copy video URL" @click.stop="handleCopyPlain(src)">
          <v-icon size="16" color="white">{{ copied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
        </v-btn>
        <a :href="src" target="_blank" rel="noopener noreferrer" download @click.stop>
          <v-btn v-if="options.download" icon title="Download video">
            <v-icon size="18" color="white">mdi-download</v-icon>
          </v-btn>
        </a>
        <v-btn icon title="Close" @click.stop="closePreview">
          <v-icon size="20" color="white">mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="preview-video__stage">
        <video class="preview-video__media" controls playsinline :src="src" @click.stop />
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { copyPlain } from './utils';

export default {
  name: 'PreviewVideo',
  props: {
    src: {
      type: String,
      required: true,
    },
    showPreview: {
      type: Boolean,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        download: true,
        copy: true,
      }),
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    async handleCopyPlain(text) {
      try {
        await copyPlain(text);
        this.timeoutCopy();
      } catch (error) {
        console.error('Error while copying text:', error);
        this.$store.commit('setMessages', {
          type: 'error',
          messages: 'Could not copy URL',
        });
      }
    },
    timeoutCopy() {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 1000);
    },
    onDialogInput(val) {
      if (!val) this.closePreview();
    },
    closePreview() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.preview-video-container {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
}

.preview-video__topbar {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  padding: 16px 16px 8px;
  flex: 0 0 auto;
}

.preview-video__stage {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px 16px;
}

.preview-video__media {
  display: block;
  max-height: calc(100vh - 176px);
  max-width: calc(100vw - 224px);
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  background: #000;
}
</style>
